import * as Yup from 'yup'

import { generalPasswordRegx } from '../../common/components/utils/Regx'

export const formValidator = (password: string) =>
  Yup.object({
    password: Yup.string()
      .required('No password provided')
      .min(8, 'Please enter a valid password')
      .matches(generalPasswordRegx, 'Please enter a valid password'),
    passwordConfirmation: Yup.string()
      .oneOf([password], 'Password doesn’t match. Try again')
      .required('Password confirmation is required!'),
  })
